module.exports = __webpack_public_path__ + "img/sheremetevo.66faf0ad.png";